import { render, staticRenderFns } from "./Songoroo-admins.vue?vue&type=template&id=bdae2466&scoped=true&"
import script from "./Songoroo-admins.vue?vue&type=script&lang=ts&"
export * from "./Songoroo-admins.vue?vue&type=script&lang=ts&"
import style0 from "./Songoroo-admins.vue?vue&type=style&index=0&id=bdae2466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdae2466",
  null
  
)

export default component.exports